import { Box } from "@mui/material";
import type { ReportField } from "../../../../../../../api/types/svTypes.ts";
import { isAggregationBased } from "../../../utilities/fieldsHelper.ts";
import BiErrorCodeComponent from "../common/bi-error/BiErrorCodeComponent.tsx";
import PreviewComponentAlert from "../common/PreviewComponentAlert.tsx";
import ValidationState from "../common/ValidationState.tsx";
import type { TitleDataReturnType } from "./hooks/tileData.types.ts";
import TilePreview from "./TilePreview.tsx";
import { stopEventPropagation } from "../../../utilities/stopEventPropagation.ts";

interface Props {
  data: TitleDataReturnType;
  fields: ReportField[];
}

const PreviewComponent = ({ data, fields }: Props) => {
  const fieldsAreEmpty = fields.length === 0;

  if (fieldsAreEmpty) return <></>;

  return (
    <BiErrorCodeComponent errorMessage={data.error}>
      <PreviewComponentAlert error={data.error} failedMeasures={data.failedMeasures} />
      <ValidationState state={data.configurationValidity} fields={getAggregationBased(fields)}>
        <Box sx={{ justifyContent: "start", width: "100%" }} onDrop={stopEventPropagation}>
          <TilePreview value={data.value} delta={undefined} isLoading={data.isLoading} period={data.period} />
        </Box>
      </ValidationState>
    </BiErrorCodeComponent>
  );
};

export default PreviewComponent;

function getAggregationBased(fields: ReportField[]): ReportField[] {
  return fields.filter(isAggregationBased);
}
